// extracted by mini-css-extract-plugin
export default {"sideNavWrapper":"side-nav-wrapper--UcgevskRha2oBJRiVijC","logo":"logo--EXhCEsYXp0Ce3_lL4SGQ","container":"container--RqrC2YNvZy9x3Lv5FWQD","list":"list--EQyxARDS3WMcKtUIBHE4"};